import { IHeWizardState } from './interfaces/he-wizard-state'

export default class HeWizardState implements IHeWizardState {
  public isHeWizardVisible = false
  public isDuplicateJobOpen = false
}
